import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn",
    style: _normalizeStyle({ '--hex-color': _ctx.color })
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 4))
}